import React, { FunctionComponent } from 'react';
import { BreakpointQueryName, ExpandableContent } from '@doveit/lego';
import DefinitionList from '../../../components/definition-list/DefinitionList';
import * as styles from './ListingDetails.style';

export interface ListingDetailsProps {
  details: {
    term: string,
    description: string,
  }[],
}

export const splitDetails = (arr: any[]) => {
  const pivot = Math.floor(arr.length / 2);

  return [
    arr.slice(0, pivot),
    arr.slice(pivot, arr.length),
  ];
};

const ListingDetails: FunctionComponent<ListingDetailsProps> = ({
  details,
}) => {
  const [first, second] = splitDetails(details);

  return (
    <div css={styles.base}>
      <div css={styles.list}>
        <DefinitionList items={first} />
      </div>

      <div css={styles.list}>
        <ExpandableContent
          openLabel="Mostra tutti i dettagli"
          closeLabel="Nascondi i dettagli aggiuntivi"
          visibleFrom={BreakpointQueryName.MD}
        >
          <DefinitionList items={second} />
        </ExpandableContent>
      </div>
    </div>
  );
};

export default ListingDetails;
